var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login columns p-t-xxl" },
    [
      _c("div", { staticClass: "column is-4 is-offset-4" }, [
        _c(
          "div",
          { staticClass: "box p-lg" },
          [
            _c("FlashMessage", { attrs: { messages: _vm.flashMessages } }),
            _c("img", {
              staticClass: "has-image-centered p-l-lg p-r-lg p-b-md",
              attrs: {
                src: require("@/assets/company-logo.png"),
                alt: "SocanApp"
              }
            }),
            _c("div", { staticClass: "field" }, [
              _c(
                "p",
                { staticClass: "control has-icons-left has-icons-right" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.username,
                        expression: "username"
                      }
                    ],
                    staticClass: "input",
                    class: { "is-danger": _vm.submitted && !_vm.username },
                    attrs: { type: "email", placeholder: "ID" },
                    domProps: { value: _vm.username },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.username = $event.target.value
                      }
                    }
                  }),
                  _vm._m(0),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !(_vm.submitted && !_vm.username),
                          expression: "!(submitted && !username)"
                        }
                      ],
                      staticClass: "icon is-small is-right"
                    },
                    [_c("i", { staticClass: "fas fa-check" })]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.submitted && !_vm.username,
                          expression: "submitted && !username"
                        }
                      ],
                      staticClass: "icon is-small is-right"
                    },
                    [_c("i", { staticClass: "fas fa-exclamation-triangle" })]
                  )
                ]
              ),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.submitted && !_vm.username,
                      expression: "submitted && !username"
                    }
                  ],
                  staticClass: "help is-danger"
                },
                [_vm._v(_vm._s(_vm.$t("messages.username_required")))]
              )
            ]),
            _c("div", { staticClass: "field" }, [
              _c(
                "p",
                { staticClass: "control has-icons-left has-icons-right" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password"
                      }
                    ],
                    staticClass: "input",
                    class: { "is-danger": _vm.submitted && !_vm.password },
                    attrs: { type: "password", placeholder: "Password" },
                    domProps: { value: _vm.password },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.password = $event.target.value
                      }
                    }
                  }),
                  _vm._m(1),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !(_vm.submitted && !_vm.username),
                          expression: "!(submitted && !username)"
                        }
                      ],
                      staticClass: "icon is-small is-right"
                    },
                    [_c("i", { staticClass: "fas fa-check" })]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.submitted && !_vm.username,
                          expression: "submitted && !username"
                        }
                      ],
                      staticClass: "icon is-small is-right"
                    },
                    [_c("i", { staticClass: "fas fa-exclamation-triangle" })]
                  )
                ]
              ),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.submitted && !_vm.password,
                      expression: "submitted && !password"
                    }
                  ],
                  staticClass: "help is-danger"
                },
                [_vm._v(_vm._s(_vm.$t("messages.password_required")))]
              )
            ]),
            _c("div", { staticClass: "field has-text-centered" }, [
              _c("p", { staticClass: "control has-text-centered m-t-lg" }, [
                _c(
                  "button",
                  {
                    staticClass: "button is-info",
                    attrs: { disabled: _vm.loggingIn },
                    on: { click: _vm.handleSubmit }
                  },
                  [_vm._v(_vm._s(_vm.$t("button.login")))]
                )
              ]),
              _c("p", { staticClass: "m-t-md" }, [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.handleChangeLang("jp")
                      }
                    }
                  },
                  [_vm._v("日本語")]
                ),
                _c("span", [_vm._v("|")]),
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.handleChangeLang("en")
                      }
                    }
                  },
                  [_vm._v("English")]
                )
              ])
            ])
          ],
          1
        )
      ]),
      _c("b-loading", {
        attrs: { "is-full-page": true, active: _vm.loggingIn },
        on: {
          "update:active": function($event) {
            _vm.loggingIn = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon is-small is-left" }, [
      _c("i", { staticClass: "fas fa-envelope" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon is-small is-left" }, [
      _c("i", { staticClass: "fas fa-lock" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }